export default {
  // 新订单列表
  all: ' All ',
  toPay: 'To Pay',
  toDispatch: 'To Dispatch',
  inTransit: 'In Transit',
  completed: 'Completed',
  canceled: 'Canceled',
  rejected: 'Rejected',
  inTransitStatus: 'In Transit Status',
  toPickupByLogistics: 'To Receive By Logistics',
  pickedUpByLogistics: 'Received By Logistics',
  orderTime: 'Order Time',
  paymentTime: 'Payment Time',
  dispatchTime: 'Dispatch Time',
  completeTime: 'Complete Time',
  noLimit: 'No Limit',
  today: 'Today',
  yesterday: 'Yesterday',
  recent7Days: 'Recent 7 Days',
  recent30Days: 'Recent 30 Days',
  recent90Days: 'Recent 90 Days',
  orderNumber: 'Order Number',
  billNumber: 'Bill Number',
  buyerID: 'Buyer ID',
  skuID: 'SKU ID',
  listingID: 'Listing ID',
  vendorProductID: 'Vendor Product ID',
  fulfillType: 'Fulfill Type',
  productName: 'Product Name',
  paymentType: 'Payment Type',
  fullyPrepaid: 'Fully Prepaid (online pay)',
  partialPrepaid: 'Partial Prepaid (pre-pay)',
  payOnDelivery: 'Pay on Delivery (cod)',
  paymentStatus: 'Payment Status',
  unpaid: 'Unpaid',
  paid: 'Paid',
  resetFilter: 'Reset Filter',
  export: 'Export',
  fold: 'Fold',
  more: 'More',
  batchOperation: 'Batch Operation',
  dispatch: 'Dispatch',
  printWaybill: 'Print Waybill',
  orderAmount: 'Order Amount',
  skus: 'SKUs',
  qty: 'Qty',
  operation: 'Operation',
  product: 'Product',
  variant: 'Variant',
  unitPrice: 'Unit Price',
  detail: 'Detail',
  printList: 'Print List',
  trackOrder: 'Track Order',
  deleted: 'Deleted',
  logisticsInformation: 'Logistics Information',
  trackNo: 'Track No.',
  close: 'Close',
  deliveryAddress: 'Delivery Address',
  parcel: 'Parcel',
  startDate: 'Start Date',
  endDate: 'End Date',
  search: 'Search',
  printListTip: 'Item list had printed before. Are you sure print again?',
  printPackingList: 'Print Packing List',
  registerLog: 'Unable to dispatch. Please register or log in to the platform logistics account first.',
  supplementRequired: 'Unable to dispatch. Please supplement the required customs information in the product details editing section.',
  declaredValue: 'Unable to dispatch. The declared value of the goods in the related order exceeds the limit.',
  goToSettings: 'Go to settings',
  goToSupplement: 'Go to supplement',
  goAdjust: 'Go adjust',
  cancel: 'Cancel',
  dispatchingPanel: 'Dispatching Panel',
  doNotSupportPackage: 'Do not support package consolidation within a single order.',
  logisticsMethod: 'Logistics method',
  platformLogistics: 'Deliver by platform logistics (KiliExpress)',
  fulfillBySeller: 'Fulfill by seller',
  usePlatformPacking: 'Use platform packing service?',
  yes: 'Yes',
  no: 'No',
  domesticCourier: 'Domestic courier',
  courierWaybill: 'Courier waybill',
  remark: 'Remark',
  batchApply: 'Batch Apply',
  orderInformation: 'Order Information',
  platformWaybill: 'Platform Waybill',
  kiliExpress: 'Kiliexpress',
  firstLegService: 'Unable to dispatch. Your first-leg service balance is too low',
  topUp: 'Top up',
  pleaseChoose: 'Please select',
  pleaseEnter: 'Please input',
  inDispatch: 'In dispatching',
  failedToDispatch: 'Failed to dispatch',
  dispatched: 'Dispatched',
  orderStatus: 'Order Status',
  dispatchStatus: 'Status',
  yourOrderDispatchClose: `Your order is being processed for bulk dispatching. Closing the popup will stop the dispatching. Successfully dispatched orders won't be reversed.`,
  continueDispatching: 'Continue Dispatching',
  terminateDispatching: 'Terminate Dispatching',
  dispatchCompleted: 'Dispatching Completed({0} successful, {1} failed)',
  orderNoSign: 'Order No.'
}
